// removed by extract-text-webpack-plugin
module.exports = {"side_tab_container":"_2DDucIKViEhVMpKLn2AU02","selected":"_7aZ1RNa9gdjig41NExKS7","side_tab_wrapper":"J5VhTORr_s4U7zJSiihef","side_tab_content":"_2eIjXfwPMYfHbfKkzFB9C-","error":"_3gCsomcW0r_MUEKAmyNecU"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinarySideTab/BinarySideTab.scss
// module id = 2303
// module chunks = 1